/// <amd-module name="Wit/Filter/AssignedToFilterProvider" />
import { equals } from "VSS/Core/Util/String";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { WiqlOperators } from "Wit/Common/WiqlOperators";
import { FieldFilterProvider } from "Wit/Filter/FieldFilterProvider";
import { IFilter, IFilterProvider } from "Wit/Filter/FilterManager";
import { WorkItemIdentityRef } from "Wit/Identity/Interfaces/WorkItemInterfaces";
import { IIdentityReference, isIdentityRef, isWorkItemIdentityRef, parseUniquefiedIdentityName } from "Wit/Identity/Utilities/WorkItemIdentityHelper";
import { UnassignedFilterItem } from "./FilterValueProviders";
import { IVssPageContext } from "VSS/Platform/Context";

export class AssignedToFilterProvider extends FieldFilterProvider implements IFilterProvider {
    constructor(private currentUser: IdentityRef, protected pageContext: IVssPageContext) {
        super(CoreFieldRefNames.AssignedTo);
    }

    public setFilter(filter: IFilter) {
        super.setFilter(filter);

        const filterValues = Object.keys(this._filterValueMap);
        for (const filterValue of filterValues) {
            // Resolve filter value
            if (equals(filterValue, WiqlOperators.MacroMe, true)) {
                // Get current user and filter on that

                const currentUserValue = this.currentUser.uniqueName;
                delete this._filterValueMap[filterValue];
                this._filterValueMap[currentUserValue] = true;
            }
        }
    }

    /**
     * Override for IdentityRef specific processing.
     * @param value
     */
    protected matchesFilter(value: string | WorkItemIdentityRef | IdentityRef): boolean {
        // if value is falsy, the field is empty and we'll fall back to unassigned
        let identity: IIdentityReference = undefined;
        if (value && !isWorkItemIdentityRef(value) && !isIdentityRef(value)) {
            // Fall back to the FieldFilterProvider for default implementation
            identity = parseUniquefiedIdentityName(value);
            if (!identity.uniqueName) {
                return super.matchesFilter(value);
            }
        }
        
        const text = identity
            ? identity.uniqueName
            : value
            ? (value as WorkItemIdentityRef)?.identityRef?.uniqueName ??
              (value as IdentityRef).uniqueName ??
              (value as WorkItemIdentityRef)?.identityRef?.displayName ??
              UnassignedFilterItem.key
            : UnassignedFilterItem.key;

        return this._filterValueMap.hasOwnProperty(text);
    }
}
